import { render, staticRenderFns } from "./AddSignature.vue?vue&type=template&id=20a94dee&scoped=true&"
import script from "./AddSignature.vue?vue&type=script&lang=js&"
export * from "./AddSignature.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=20a94dee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a94dee",
  null
  
)

export default component.exports